import React, { Component } from 'react';
import axios from "axios";
import { connect, ReactReduxContext } from 'react-redux';
import { withCookies, Cookies } from 'react-cookie';
import { ducks } from '../../ducks';
import { InteractionRequiredAuthError } from 'msal'

import { MsalProvider, useMsal, MsalAuthenticationTemplate, } from "@azure/msal-react";
import { PublicClientApplication, InteractionType, } from "@azure/msal-browser";

import environment from '../../environments/base';

const env = 'production';
const settings = environment.storeauthentication[env];

const domain = (typeof window !== 'undefined') ? settings.domain : '';
const policy = (typeof window !== 'undefined') ? settings.policy : '';
const authority = (typeof window !== 'undefined') ? settings.authority : '';

// Msal Configurations
const config = {

  auth: {
    authority: `${domain}/${policy}`,
    clientId: (typeof window !== 'undefined') ? settings.clientId : '',
    knownAuthorities: [`${authority}`],
    redirectUri: (typeof window !== 'undefined') ? window.location.origin : ''
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  }
};

// Authentication Parameters
const authRequest = {
  scopes: [
    'openid',
    'profile'
  ],
}

const accountOperations = ducks.account.operations
const { cart: cartDuck } = ducks;
const { operations } = cartDuck
const { closeAddTo } = operations
const pca = new PublicClientApplication(config);

class StorePortalAuth extends Component {

  constructor(props) {
    super(props);

    this.fields = props.fields?.data?.fields || {};
    const { storeLoggedin, idToken } = props;
  }

  async componentDidMount() {
    await pca.handleRedirectPromise().
      then(async (tokenResponse) => {
        if (tokenResponse !== null) {
          console.log(tokenResponse);
          let idToken = tokenResponse.idToken;
          await this.props.postAccount(idToken);
        } else {
          if (this.props.storeLoggedin) {
            await this.props.postAccount(this.props.idToken);
          }
          else {
            await pca.loginRedirect()
          }
        }

      })
      .catch(error => {
        console.log(error);
      })

  }


  async componentWillReceiveProps(newProps) {
    console.log(newProps);
    if (newProps.storeLoggedin !== this.props.storeLoggedin) {
      if (!this.state.storeLoggedin) {
        if (!newProps.storeLoggedin) {
          await pca.loginRedirect();
        }
      }
    }
  }

  render() {
    return (
      <ReactReduxContext.Consumer>
        {((context) => {
          return (
            <MsalProvider instance={pca} reduxStore={context.store}>
              <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={authRequest}>
              </MsalAuthenticationTemplate>

            </MsalProvider>

          )
        }


        ).bind(this)

        }
      </ReactReduxContext.Consumer>
    );
  }
};


const mapStateToProps = (state) => {
  console.log(state);
  return {
    storeLoggedin: state.storeLoggedin,
    idToken: state.idToken
  };
}


const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(closeAddTo()),
  postAccount: token => dispatch(accountOperations.postStoreAccount(token)),
  loginSuccess: token => dispatch(accountOperations.storeLoginSuccess(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(StorePortalAuth));


